import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import { useMutation } from '@apollo/client'
import { CREATE_TACHO_DRIVER_FILE_MUTATION } from '../../mutations'
import { getTachoFileType } from '../../consts'
import { TachoFileUploadModal } from './tacho-file-upload-modal'
import { UploadModalButton } from './upload-modal-button'

const ERR_WRONG_TYPE = 'WRONG_TYPE'

interface UploadTachoDriverFileProps {
  onUploadSuccess?: () => void
}

export const UploadTachoDriverFile: React.FC<UploadTachoDriverFileProps> = ({
  onUploadSuccess,
}) => {
  const translations = useTranslate({
    uploadDriverCardFiles: 'activities.upload-driver-card-files',
    wrongFileTypeDriver: 'activities.wrong-file-type-driver',
  })

  const [addFile] = useMutation(CREATE_TACHO_DRIVER_FILE_MUTATION)

  return (
    <UploadModalButton
      renderModal={({ onClose }) => (
        <TachoFileUploadModal
          title={translations.uploadDriverCardFiles}
          validateFile={file =>
            getTachoFileType(file.name) === 'vehicle' ? ERR_WRONG_TYPE : null
          }
          mapError={code =>
            code === ERR_WRONG_TYPE
              ? translations.wrongFileTypeDriver
              : undefined
          }
          upload={async file => {
            const result = await addFile({
              variables: {
                input: { file, fileName: file.name, driverCardNumber: '' },
              },
            })
            if (result.errors?.length || !result.data?.createTachoDriverFile) {
              return { ok: false, error: result.errors?.[0]?.message ?? '' }
            }
            return {
              ok: true,
              id: result.data.createTachoDriverFile.tachoDriverFile?.id,
            }
          }}
          onClose={onClose}
          onUploadSuccess={onUploadSuccess}
        />
      )}
    />
  )
}
